<template>
    <div :class="{'field': true, 'field--error': props.isValidate || (props.isValidate && props.required && empty(props.modelValue))}">
        <div class="field__label">{{ props.label }}</div>
        <input :type="type" :placeholder="props.label" class="field__input" :value="props.modelValue"
            @input="(e) => emit('update:modelValue', e.target.value)" @keyup.enter="emit('submit')" />
    </div>
</template>

<script setup>
const props = defineProps({
    modelValue: {},
    label: {},
    required: { default: false },
    isValidate: { default: false },
    type: { default: 'text' }
})

const emit = defineEmits(['update:modelValue', 'submit'])

const empty = (val) => {
    return val == '' || val == null
}
</script>
<style>
@import url('./Input.css');
</style>